/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { mapValues } from '../runtime';
import { FxIdDomainSettingsAdvertisementGtagOptionsDefaultFromJSON, FxIdDomainSettingsAdvertisementGtagOptionsDefaultToJSON, } from './FxIdDomainSettingsAdvertisementGtagOptionsDefault';
import { FxIdDomainSettingsAdvertisementGtagForDomainOptionsFromJSON, FxIdDomainSettingsAdvertisementGtagForDomainOptionsToJSON, } from './FxIdDomainSettingsAdvertisementGtagForDomainOptions';
/**
 * Check if a given object implements the FxIdDomainSettingsAdvertisementGtagOptions interface.
 */
export function instanceOfFxIdDomainSettingsAdvertisementGtagOptions(value) {
    return true;
}
export function FxIdDomainSettingsAdvertisementGtagOptionsFromJSON(json) {
    return FxIdDomainSettingsAdvertisementGtagOptionsFromJSONTyped(json, false);
}
export function FxIdDomainSettingsAdvertisementGtagOptionsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'Default': json['Default'] == null ? undefined : FxIdDomainSettingsAdvertisementGtagOptionsDefaultFromJSON(json['Default']),
        'Domains': json['Domains'] == null ? undefined : (mapValues(json['Domains'], FxIdDomainSettingsAdvertisementGtagForDomainOptionsFromJSON)),
    };
}
export function FxIdDomainSettingsAdvertisementGtagOptionsToJSON(json) {
    return FxIdDomainSettingsAdvertisementGtagOptionsToJSONTyped(json, false);
}
export function FxIdDomainSettingsAdvertisementGtagOptionsToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'Default': FxIdDomainSettingsAdvertisementGtagOptionsDefaultToJSON(value['Default']),
        'Domains': value['Domains'] == null ? undefined : (mapValues(value['Domains'], FxIdDomainSettingsAdvertisementGtagForDomainOptionsToJSON)),
    };
}
//# sourceMappingURL=FxIdDomainSettingsAdvertisementGtagOptions.js.map